// TODO [SCMPWEB-9518]: Remove after Proteus A/B test ends
// Number of hero articles (positions 1-5) locked to the SSR legacy queue.
// Proteus variant:1 edges skip the first N to fill positions 6-18.
export const HERO_TOP_STORIES_COUNT = 5;
